import { authenticatedAjax, REQUEST } from "src/co/sura/config/ajax-wrapper";
import { AnyAction } from "redux";
import { errorAutorizacion } from "src/co/sura/inicio/modulos/inicioActions";
import { 
    CONSULTAR_ESTRUCTURA_EMPRESA, 
    ERROR_CONSULTANDO_ESTRUCTURA_EMPRESA, 
    ESTRUCTURA_EMPRESA_CONSULTADA,
    estructuraEmpresaConsultada, 
    errorConsultandoEstructuraEmpresa,
} from "./estructuraEmpresasActions";

export const consultarEstructuraEmpresaEpic = action$ =>
    action$.ofType(CONSULTAR_ESTRUCTURA_EMPRESA)
        .mergeMap((action: any) => {
            let params = new URLSearchParams();
        
            if (action.dniEmpleador) params.set('dniEmpleador', action.dniEmpleador);
            if (action.consecutivoConsulta) params.set('consecutivoConsulta', action.consecutivoConsulta.toString());
            if (action.usuario) params.set('usuario', action.usuario);

            const url = `sat/estructura-empresas?${params.toString()}`;
        
            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return estructuraEmpresaConsultada(respuesta.datos, respuesta.mensajeRespuesta);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoEstructuraEmpresa()];
                });
        });

export const estructuraEmpresasReducer = ( state = {
    estadoConsulta: REQUEST.NONE,
    mensajeAction: undefined,
    mensajeUsuario: false,
    estructuraEmpresa: undefined,
    estructuraSuraEmpresa: undefined,
    consecutivoProceso: undefined,
    error: undefined
}, action: AnyAction) => {
    switch(action.type) {

        case CONSULTAR_ESTRUCTURA_EMPRESA:
            return {
                ...state,
                estadoConsulta: REQUEST.PENDING,
                mensajeAction: undefined,
                mensajeUsuario: false,
                estructuraEmpresa: undefined,
                estructuraSuraEmpresa: undefined
            };
        case ESTRUCTURA_EMPRESA_CONSULTADA:
            return {
                ...state,
                estadoConsulta: REQUEST.SUCCESS,
                estructuraEmpresa: action.respuestaEstructuraEmpresa ? action.respuestaEstructuraEmpresa.estructuraSatEmpleador : undefined,
                estructuraSuraEmpresa: action.respuestaEstructuraEmpresa ? action.respuestaEstructuraEmpresa.estructuraSuraEmpleador : undefined,
                mensajeUsuario: action.mensajeRespuesta,
                consecutivoProceso: action.respuestaEstructuraEmpresa.consecutivoProceso,
                error: action.respuestaEstructuraEmpresa.error
            };
        case ERROR_CONSULTANDO_ESTRUCTURA_EMPRESA:
            return {
                ...state,
                estadoConsulta: REQUEST.ERROR,
                estructuraEmpresa: undefined,
                estructuraSuraEmpresa: undefined
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/modulos/estructuraEmpresasReduces.ts